import { createGlobalStyle } from 'styled-components';
import bgImage from '~/assets/bg.jpg';

export default createGlobalStyle`
*{
    margin:0;
    padding: 0;
    outline: 0;
    /* list-style: none; */
    box-sizing: border-box;
  }
  ul{
    list-style:none;
  }
  *:focus{
    outline: 0;
  }
  html, body, #root{
    height: 100%;    
  }
  html{   
    overflow-x: hidden;
  }
  body{
    -webkit-font-smoothing: antialiased;
  }
  body{
    font-family: 'Montserrat', sans-serif;
    font-size: 16px;
    background: url(${bgImage}) center top no-repeat;
    @media (max-width: 768px){
      background: url(${bgImage}) center top repeat-y;
    }
  }
.slick-track{
  display: flex;
}
  .slick-slide{
    float: none;
    height: auto;
    &>div{
      height: 100%;
    }
  }

`;
